/* clientFolderGuard — sdílený „dirty guard" mezi klientskou složkou a jejím Hostem.
 *
 * PROČ: složka (ClientDetailRaynet) má dialog neuložených změn, ale zavírají/přepínají
 * ji EXTERNÍ cesty (GlobalTabBar „×"/„Zavřít vše", Cmd+K/navigace přes
 * close-all-client-folders, přepnutí na jiného klienta, aktivace sekce). Ty jdou VŠECHNY
 * přes listenery v ClientFolderHost — jediný vlastník overlaye. Host proto před teardownem
 * zavolá requestFolderClose(proceed): je-li složka „dirty", spustí se JEJÍ dialog a teardown
 * se odloží, dokud uživatel nerozhodne (Uložit a pokračovat / Zahodit / Zůstat). Bez toho
 * by se rozepsané změny při těchto akcích tiše ztratily.
 *
 * Interception přes capture-phase listenery ve složce je nespolehlivá — GlobalTabBar je
 * namountovaný dřív a na close-all reaguje před složkou. Proto centrální registr + gate v Hostu.
 */
const DEFAULT_GUARD = { isDirty: () => false, requestClose: (proceed) => proceed() };
let guard = DEFAULT_GUARD;

/** Složka se zaregistruje na mountu: isDirty() = má neuložené změny; requestClose(proceed)
 *  = ukázat dialog a proceed() spustit po potvrzení (save/zahodit), nebo hned když čisto.
 *  Vrací TOKEN (samotný objekt) pro pozdější identity-checked odregistraci. */
export function registerFolderGuard(g) {
  if (g && typeof g.isDirty === "function" && typeof g.requestClose === "function") {
    guard = g;
    return g;
  }
  return null;
}

/** Odregistrace na unmountu. IDENTITY-CHECK: resetuj JEN když je zapsaný guard pořád „ten můj".
 *  Kritické kvůli AnimatePresence sync režimu — při přepnutí klienta A→B obě složky chvíli
 *  koexistují; B se registruje první, A se odmountuje AŽ POTOM. Bez identity-checku by
 *  odcházející A vynulovala živý guard B → B by zůstala bez ochrany a rozepsané změny by se
 *  při externím zavření tiše ztratily. (Bez tokenu resetuj vždy — zpětná kompat.) */
export function clearFolderGuard(token) {
  if (token === undefined || guard === token) guard = DEFAULT_GUARD;
}

/** Host se ptá: je aktivní složka rozepsaná? */
export function folderIsDirty() {
  try { return !!guard.isDirty(); } catch { return false; }
}

/** Host chce zavřít/přepnout: je-li dirty → dialog + odklad; jinak proceed() hned. */
export function requestFolderClose(proceed) {
  try { return guard.requestClose(proceed); } catch { return proceed(); }
}
